module.exports = __webpack_public_path__ + "img/dacsee.cdc68095.jpg";